import * as Yup from "yup";

export const LoginValidationScheme = Yup.object().shape({
  email: Yup.string().email().required().label("Email"),
  password: Yup.string().required().label("Password"),
});

export const CreateStaffValidation = Yup.object().shape({
  email: Yup.string().email().required().label("Email"),
  password: Yup.string().required().label("Password"),
  phone: Yup.string()
    .matches(/^\d{10}$/, "Phone number must be exactly 10 digits")
    .required()
    .label("Phone number"),
  name: Yup.string().required().label("Full name"),
});
